import { Directive, Input, HostListener, Renderer2, ElementRef, Inject } from '@angular/core';

@Directive({
  selector: '[fieldRegexp]',
  standalone: false,
})
export class FieldRegexpDirective {
  // Позволяет обрезать символы не попадающие под регулярку.

  private _sourceRenderer: Renderer2;
  private _sourceElementRef: ElementRef;

  constructor(@Inject(Renderer2) renderer: Renderer2, @Inject(ElementRef) elementRef: ElementRef) {
    this._sourceRenderer = renderer;
    this._sourceElementRef = elementRef;
  }

  @Input() regexp: string;

  @HostListener('input', ['$event', '$event.target.value'])
  onInput(event: string, value: string): void {
    const regex = new RegExp(this.regexp, 'g');
    event['target'].value = value.replace(regex, '');
  }

  @HostListener('paste', ['$event', '$event.target.value'])
  onPaste(event: string, value: string): void {
    const regex = new RegExp(this.regexp, 'g');
    event['target'].value = value.replace(regex, '');
  }
}
